module.exports = __webpack_public_path__ + "img/xiazai@3x.ed00c1ba.svg";